import { render } from "./Sort.vue?vue&type=template&id=0b1cf28c&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"

import "@/Common/Styles/Sort.scss?vue&type=style&index=0&id=0b1cf28c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1cf28c"]])

export default __exports__